import { Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { Analytics } from "./components/Analytics";
import Home from "./pages/Home";
import AdvisoryBoard from "./pages/AdvisoryBoard";
import EventConsulting from "./pages/EventConsulting";
import Marketing from "./pages/Marketing";
import MarketingConsultation from "./pages/MarketingConsultation";
import MarketingStrategy from "./pages/MarketingStrategy";
import TimeManagement from "./pages/TimeManagement";
import Automation from "./pages/Automation";
import FinKeeper from "./pages/FinKeeper";
import Bali from "./pages/Bali";
import ResideInvestment from "./pages/ResideInvestment";
import VillaRent from "./pages/VillaRent";
import CocoonInvestment from "./pages/CocoonInvestment";
import InstagramAds from "./pages/InstagramAds";
import Partnership from "./pages/Partnership";
import About from "./pages/About";
import Links from "./pages/Links";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
      <Route path="/advisory-board" element={<AdvisoryBoard />} />
      <Route path="/event-consulting" element={<EventConsulting />} />
      <Route path="/marketing" element={<Marketing />} />
      <Route path="/marketing/consultation" element={<MarketingConsultation />} />
      <Route path="/marketing/strategy" element={<MarketingStrategy />} />
      <Route path="/time-management" element={<TimeManagement />} />
      <Route path="/automation" element={<Automation />} />
      <Route path="/finkeeper" element={<FinKeeper />} />
      <Route path="/bali" element={<Bali />} />
      <Route path="/bali/reside" element={<ResideInvestment />} />
      <Route path="/bali/villa-rent" element={<VillaRent />} />
      <Route path="/bali/cocoon" element={<CocoonInvestment />} />
      <Route path="/instagram-ads" element={<InstagramAds />} />
      <Route path="/partnership" element={<Partnership />} />
      <Route path="/about" element={<About />} />
        <Route path="/links" element={<Links />} />
      </Routes>
    </>
  );
}
